import * as angular from 'angular';
import {RootScope} from '../types/angular-types';
import * as $ from 'jquery';
import Features from '../feature-manager/Features';
import AppConstants from '../gorillaboy/AppConstants';

const DocViewerEvents = (window as any).DocViewerEvents;

    angular.module('GorillaBoy.DocumentViewer')
    .directive('pdfRender', [
        'SignalProvider',
        'DocumentService',
        'DocumentStateService',
        '$timeout',
        '$window',
        '$log',
        '$http',
        '$sce',
        '$rootScope',
        'FeatureManagerService',
        'ClientMetricsService',
        'MetricEvents',
        'AnnotationService',
        'BrowserService',
        'localStorageService',
        '$document',
        'ContentTypeFormatter',
        pdfRender
    ]);

    function pdfRender(SignalProvider, DocumentService, DocumentStateService, $timeout,
        $window, $log, $http, $sce, $rootScope: RootScope, 
        FeatureManagerService,
        ClientMetricsService, MetricEvents, AnnotationService,
        BrowserService, localStorageService, $document, ContentTypeFormatter) {
        return {
            restrict: 'E',
            replace: true,
            template: '<div class="pdfviewer-container"></div>',
            link: function($scope, $element, attrs) {
                const versionIdVsLatencyMetricHandle : any = {};
                const versionIdVsRetryLatencyMetricHandle: any = {};


                var SECOND_TO_MILLISECONDS = 1000,
                    PDFJS_IFRAME_ELEMENT_ID = "pdfJsViewerIFrame",
                    DOCUMENT_LOADING_SPINNIER = "document-loading-spinner",
                    documentStatus = AppConstants.DocumentStatus;

                var METRICS_EVENTS = {
                    PDFJS_IFRAME_EL_NOT_FOUND: {name: 'PDFJS_IFRAME_EL_NOT_FOUND'}
                };

                function resetPDFAnnotationDocumentState() {
                    $scope.documentState.pdfDataLoaded = false;
                    $scope.documentState.annotationIndexStarted = false;
                }
                var updatePendingPreviewVersionTimeoutPromise;
                var updatePendingPreviewActiveVersion = function(versionId) {
                    updatePendingPreviewVersionTimeoutPromise = null;
                    //Only check the pending preview for the passed versionId and NOT the current version, because user could have changed the version
                    if (!!DocumentStateService.activeVersion && $scope.documentState.activeVersion.VersionId === versionId) {
                        DocumentService.getDocumentVersion($scope.documentState.documentId, $scope.documentState.activeVersion.VersionId, $scope.passcode, $scope.layout.isAnonymous)
                        .success(function(data) {
                            var versionMetadata = data.Metadata;
                            if (!versionMetadata.Contributor) {
                                versionMetadata.Contributor = DocumentStateService.activeVersion.Contributor;
                            }

                            versionMetadata.VersionId = versionMetadata.Id;

                            $scope.$emit(SignalProvider.Feedback.Deselect);
                            if (versionMetadata.Status == documentStatus.DOCUMENT_STATUS_ACTIVE) {
                                $scope.documentOperationsEnabled = '';
                            } else {
                                $scope.documentOperationsEnabled = 'disabled';
                            }
                            if (versionMetadata.PdfPreviewStatus !== documentStatus.DOCUMENT_STATUS_PENDING) {
                                updatePendingPreviewPowerOf2 = 0;
                                DocumentStateService.activeVersion = versionMetadata;
                                $scope.documentState.activeVersion = {
                                    Name: DocumentStateService.activeVersion.Name,
                                    Size: DocumentStateService.activeVersion.Size,
                                    ContentType: DocumentStateService.activeVersion.ContentType,
                                    Modified: DocumentStateService.activeVersion.Modified,
                                    VersionId: DocumentStateService.activeVersion.VersionId,
                                    Status: DocumentStateService.activeVersion.Status,
                                    VersionStatus : DocumentStateService.activeVersion.VersionStatus,
                                    AnnotatedVersionAvailable: DocumentStateService.activeVersion.AnnotatedVersionAvailable,
                                    PdfPreviewStatus: DocumentStateService.activeVersion.PdfPreviewStatus
                                };
                                $scope.documentState.documentVersions[$scope.documentState.documentVersions.length - $scope.documentVersionIdToVersionNumberMap[versionMetadata.VersionId]] = versionMetadata;
                                if (versionIdVsLatencyMetricHandle[versionId]) {
                                    versionIdVsLatencyMetricHandle[versionId].stopAndEmitMetric();    
                                }                                
                                DocumentStateService.pdfReady = true;
                                getDocumentVersionUnderlays(DocumentStateService.activeVersionId);
                            } else {
                                scheduleUpdatePendingPreviewActiveVersion(versionId);
                                if (versionIdVsRetryLatencyMetricHandle[versionId]) {
                                    versionIdVsRetryLatencyMetricHandle[versionId].stopAndEmitMetric();
                                }
                            }
                        }, () => {
                            //If the call fails, reschedule the call to updatePendingPreviewActiveVersion()
                            scheduleUpdatePendingPreviewActiveVersion(versionId);
                            if (versionIdVsRetryLatencyMetricHandle[versionId]) {
                                versionIdVsRetryLatencyMetricHandle[versionId].stopAndEmitMetric();
                            }
                        });
                    }
                };

                var updatePendingPreviewPowerOf2 = 0;
                var scheduleUpdatePendingPreviewActiveVersion = function(versionId) {
                    if (updatePendingPreviewVersionTimeoutPromise) {
                        $timeout.cancel(updatePendingPreviewVersionTimeoutPromise);
                        updatePendingPreviewVersionTimeoutPromise = null;
                    }
                    updatePendingPreviewPowerOf2 = updatePendingPreviewPowerOf2 + 1;
                    //exponential backoff
                    updatePendingPreviewVersionTimeoutPromise = $timeout(updatePendingPreviewActiveVersion, Math.min(Math.pow(2, updatePendingPreviewPowerOf2), 16) * SECOND_TO_MILLISECONDS, true, versionId);
                };

                var annotationIndexPendingPromise;
                var getDocumentVersionUnderlays = function(versionId) {
                    resetPDFAnnotationDocumentState();
                    openLoadingSpinner();
                    // Download the underlays for the active version.
                    return DocumentService.getDocumentVersionPreview($scope.documentState.documentId, versionId, $scope.passcode, $scope.layout.isAnonymous)
                        .success(function(data) {
                            var url = data.Metadata.Preview.PREVIEW,
                                annotationIndexUrl = data.Metadata.Preview.ANNOTATION_INDEX;

                            $scope.pdfUnderlayUrl = url;
                            if (annotationIndexUrl &&
                                ($scope.allowFeedback() || $scope.documentFormData.disableFeedback ||
                                $scope.documentState.activeVersion.VersionStatus === AppConstants.DOCUMENT_VERSION_STATUS.DRAFT)) {
                                $log.info(`Fetching annotation index for ${$scope.documentState.documentId} AND ${versionId}`);
                                //Only if the user can annotate then download the annotation index
                                annotationIndexPendingPromise = AnnotationService.getAnnotationIndex(annotationIndexUrl);
                            }

                            $scope.documentState.pdfUnderlayShown = (url !== null);
                            if (DocumentStateService.activeVersion && $scope.documentState.activeVersion.PdfPreviewStatus == documentStatus.DOCUMENT_STATUS_PENDING) {
                                // setup timer to retry
                                versionIdVsLatencyMetricHandle[versionId] = $rootScope.metricServiceInstance.newLatencyMetric('DocumentViewer.WaitingForPendingPreview');
                                versionIdVsRetryLatencyMetricHandle[versionId] = $rootScope.metricServiceInstance.newLatencyMetric('DocumentViewer.RetryForPendingPreview');
                                scheduleUpdatePendingPreviewActiveVersion(versionId);
                            } else if (DocumentStateService.pdfReady) {
                                if (!$scope.$$destroyed) {
                                    openUnderlay(url);
                                }
                            }
                        })
                        .error(function(data) {
                            // TODO : Avoid handling the error here. Error occurs in this case when the client
                            // tries to get the underlays even before the source file has been uploaded to S3.
                            // Correct order of steps:
                            // 1. InitiateDocumentVersionUpload
                            // 2. Upload the Source file to S3
                            // 3. CompleteDocumentVersionUpload
                            // 4. Get Underlays to be shown in the UI (When ready)

                            // Getting the underlays after a particular refresh timeout is a tenporary fix.
                            scheduleUpdatePendingPreviewActiveVersion(versionId);
                        });
                };

                /*
                 * Returns the iframe element of the PDFJS renderer in a portable way
                 */
                function getIframeElement() {
                    if (BrowserService.isIE()) {
                        return window[PDFJS_IFRAME_ELEMENT_ID];
                    }
                    const iframeEl: any = document.getElementById(PDFJS_IFRAME_ELEMENT_ID);
                    if (iframeEl) {
                        return iframeEl.contentWindow;
                    }
                }

                function onAspectRatioReturned(response) {
                    var ar = response.payload.aspectRatio;
                    if (ar) {
                        if (ar > 1.5) {
                            $scope.documentState.documentViewerBridge.setPDFViewerScale("page-height");
                        }
                        else if (ar < 0.66) {
                            $scope.documentState.documentViewerBridge.setPDFViewerScale("page-width");
                        }
                        else {
                            $scope.documentState.documentViewerBridge.setPDFViewerScale("page-fit");
                        }
                    }
                    // Unregister itself after response is received and processed.
                    $scope.documentState.documentViewerBridge.off(DocViewerEvents.RETURN_CURRENT_PAGE_ASPECT_RATIO, onAspectRatioReturned);
                }

                var openLoadingSpinner = function() {
                    $("#" + DOCUMENT_LOADING_SPINNIER).remove();
                    $element.append(`<div id="${DOCUMENT_LOADING_SPINNIER}" class="progress-indicator" style="position: absolute;top: calc(50% - 40px);left: calc(50% - 50px);"></div>`);
                }

                var openUnderlay = function(url) {
                    $scope.pdfJsViewerUrl = $sce.trustAsResourceUrl(AppConstants.PDF_VIEWER_BASE_URL + "/viewer.html?file=" + encodeURIComponent(url));
                    $("#" + DOCUMENT_LOADING_SPINNIER).remove();
                    $("#" + PDFJS_IFRAME_ELEMENT_ID).remove();
                    //We should insert iframe directly with the right SRC value. We cannot use ng-src and have this iframe in a template becuase change in ngSrc value will add
                    //extraneous history entries and interfere with Back button functionality.
                    $element.append("<iframe src=\"" + $scope.pdfJsViewerUrl + "\" style=\"height: 100%;width: 100%;border: 0px;\" " +
                        "allowfullscreen=\"true\" allow-presentation=\"true\" allow-popups=\"true\" id=\""+ PDFJS_IFRAME_ELEMENT_ID  +"\"></iframe>");
                    var iframeEl = getIframeElement();
                    if (!iframeEl) {
                        ClientMetricsService.recordCounterEvent(METRICS_EVENTS.PDFJS_IFRAME_EL_NOT_FOUND, 1);
                    } else {
                        $scope.documentState.documentViewerBridge.init(iframeEl);
                        if (ContentTypeFormatter.isImageFile($scope.documentState.activeVersion.ContentType) && 
                            FeatureManagerService.isFeatureEnabled(Features.UI.IMAGE_NAV)) {
                            $scope.documentState.documentViewerBridge.getCurrentPageAspectRatio();
                            $scope.documentState.documentViewerBridge.on(DocViewerEvents.RETURN_CURRENT_PAGE_ASPECT_RATIO, onAspectRatioReturned);
                            $scope.$on('$destroy', function() {
                                $scope.documentState.documentViewerBridge.off(DocViewerEvents.RETURN_CURRENT_PAGE_ASPECT_RATIO, onAspectRatioReturned);                    
                            });
                        }
                    }
                };

                var documentLoaded = function() {
                    if ($scope.allowFeedback() || $scope.documentFormData.disableFeedback ||
                        $scope.documentState.activeVersion.VersionStatus === AppConstants.DOCUMENT_VERSION_STATUS.DRAFT) {
                        //still pass the annotation index if the feedback is disabled
                        if (annotationIndexPendingPromise) {
                            annotationIndexPendingPromise.then(function(data) {
                                $scope.documentState.documentViewerBridge.receiveAnnotationIdex(data);
                            }, () => {
                                $log.error(`Fetching annotation index failed for ${$scope.documentState.documentId}`);
                            });
                        }
                    }
                    //If a feedback input is not shown, focus the document viewer so that scroll bars, find keyboard shortcuts continue to work
                    var iframe = getIframeElement();
                    if (iframe) {
                        iframe.focus();
                    }
                };


                $scope.documentState.documentViewerBridge.on(DocViewerEvents.DOCUMENT_LOADED, documentLoaded);
                $scope.$on('$destroy', function() {
                    if (updatePendingPreviewVersionTimeoutPromise) {
                        $timeout.cancel(updatePendingPreviewVersionTimeoutPromise);
                    }
                    $scope.documentState.documentViewerBridge.off(DocViewerEvents.DOCUMENT_LOADED, documentLoaded);                    
                });

                $scope.$on(SignalProvider.CustomClickEvent, function() {
                    // Click event happens in iframe does not propagate to the outside of the iframe. Therefore, 
                    // programmatically click the iframe to continue the click event chain
                    // put in timeout function ensures the event happens on the next tick to prevent Error: $rootScope:inprog 
                    $timeout(function() {
                        $('#'+PDFJS_IFRAME_ELEMENT_ID).click();
                    }, 0);
                });

                var dragOverTimeout;
                //When a text or a file is dragged over the iframe hide the iframe using visibility to capture that dragover
                function dragOverInProgress() {
                    $document.on('drop', dragOverEnded);
                    $document.on('dragover', topDragOverInProgress);
                    var iframeEl = document.getElementById(PDFJS_IFRAME_ELEMENT_ID);
                    if (iframeEl) {
                        iframeEl.style.visibility = "hidden";
                    }

                }

                function topDragOverInProgress() {
                    if (dragOverTimeout) {
                        clearTimeout(dragOverTimeout);
                        dragOverTimeout = null;
                    }
                    dragOverTimeout = setTimeout(dragOverEnded, 500);
                }

                function dragOverEnded() {
                    var iframeEl = document.getElementById(PDFJS_IFRAME_ELEMENT_ID);
                    if (iframeEl) {
                        iframeEl.style.visibility = "visible";
                    }
                }

                //still pass the annotation index if the feedback is disabled
                $scope.documentState.documentViewerBridge.on(DocViewerEvents.DRAG_OVER_IN_PROGRESS, dragOverInProgress);
                $scope.$on('$destroy', function() {
                    $document.off('dragover', topDragOverInProgress);
                    $document.off('drop', dragOverEnded);
                    $scope.documentState.documentViewerBridge.off(DocViewerEvents.DRAG_OVER_IN_PROGRESS, dragOverInProgress);
                });

                $scope.filepath = "";
                $scope.$on(SignalProvider.PDF.ScheduleUpdate, function(event) {
                    scheduleUpdatePendingPreviewActiveVersion($scope.documentState.activeVersion.VersionId);
                });
                $scope.$on(SignalProvider.PDF.PDFViewResetAnnotation, function(event) {
                    resetPDFAnnotationDocumentState();
                });

                $scope.$on(SignalProvider.PDF.GetUnderlaysAndRefreshFeedback, function(event, versionId, shouldRefreshFeedbackCount) {
                    if (versionId) {
                        getDocumentVersionUnderlays(versionId);
                    }
                });
                const PdfPreviewStatus = $scope.documentState.activeVersion && $scope.documentState.activeVersion.PdfPreviewStatus;
                if (PdfPreviewStatus === documentStatus.DOCUMENT_STATUS_PENDING || PdfPreviewStatus === documentStatus.DOCUMENT_STATUS_PENDING_USER_ACTION) {
                    scheduleUpdatePendingPreviewActiveVersion($scope.documentState.activeVersion.VersionId);
                } else if (PdfPreviewStatus === documentStatus.DOCUMENT_STATUS_ACTIVE) {
                    getDocumentVersionUnderlays($scope.documentState.activeVersion.VersionId);
                }
            }
        };
    }
